import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, ModalDelete } from "expano-components";
import { Dashboard } from "components";
import useDelete from "hooks/useDelete";
import AddBundle from "./components/AddBundle";
import EditBundle from "./components/EditBundle";

const BundleProducts = ({ product_id, data, refetch }) => {
  const [is_open_add_virtual_product_modal, setOpenAddVirtualProductModal] =
    useState(false);
  const [delete_product_component, setDeleteProductComponent] = useState(null);
  const [edit_product_component, setEditProductComponent] = useState(null);

  const { _delete } = useDelete({
    path: `/product_components/${delete_product_component?.id}`,
    onSuccess: () => [refetch(), setDeleteProductComponent(null)],
  });

  return (
    <Dashboard
      header={{
        icon: "info",
        title: "Produkty powiązane (bundle)",
      }}
      footer={
        <Button
          type="add"
          text="Dodaj produkt"
          onClick={() => setOpenAddVirtualProductModal(true)}
        />
      }
    >
      {is_open_add_virtual_product_modal && (
        <AddBundle
          bundle_id={product_id}
          handleClose={() => setOpenAddVirtualProductModal(false)}
          refetch={refetch}
        />
      )}
      {edit_product_component?.product_component_id && (
        <EditBundle
          {...edit_product_component}
          handleClose={() => setEditProductComponent(null)}
          refetch={refetch}
        />
      )}
      {delete_product_component?.id && (
        <ModalDelete
          handleDelete={_delete}
          handleClose={() => setDeleteProductComponent(null)}
          name={`komponent ${delete_product_component.name}?`}
        />
      )}
      {data?.length > 0 && (
        <table className="table">
          <tbody className="table__body table-body">
            {data.map(({ id, quantity, component }) => (
              <tr key={id}>
                <td style={{ width: 140 }}>
                  <Link className="text-link" to={`/products/${component?.id}`}>
                    {component?.sku}
                  </Link>
                </td>
                <td>{component?.name}</td>
                <td style={{ width: 90 }}>
                  {component?.is_virtual ? "Wirtualny" : "Prosty"}
                </td>
                <td style={{ width: 130 }}>
                  {component?.has_infinite_sales_stock
                    ? "Nielimitowane stany"
                    : "Limitowane stany"}
                </td>
                <td style={{ width: 100 }}>{quantity} szt.</td>
                <td style={{ width: 70 }}>
                  <div className="df">
                    <Button
                      type="edit"
                      onClick={() =>
                        setEditProductComponent({
                          product_component_id: id,
                          initial_component_id: component?.id,
                          initial_quantity: quantity,
                          component_default_value: {
                            label: `[${component?.sku}] ${component?.name}`,
                            value: component?.id,
                          },
                        })
                      }
                    />
                    <Button
                      type="delete-bin"
                      onClick={() =>
                        setDeleteProductComponent({
                          name: component?.name,
                          id,
                        })
                      }
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Dashboard>
  );
};

export default BundleProducts;
